import { LoadingIndicator } from './../loading-indicator/loading-indicator';
import { Component } from '@opten/compiler/metadata/component';


@Component({ className: 'js-vehicle-storage' })
export class VehicleStorageComponent {

    loadingIndicatorDark: string;
    loadingIndicator: string;
    contentElement: HTMLElement;
    formElementWrapper: HTMLElement;
    targetToLoad: string;
    language: string;
    formElement: HTMLFormElement;

    constructor(private element: HTMLElement) {
        this.loadingIndicatorDark = new LoadingIndicator().contentLoadingDark;
        this.loadingIndicator = new LoadingIndicator().contentLoading;
        this.contentElement = element;
        this.init();
    }

    init() {
        this.targetToLoad = this.contentElement.getAttribute('data-load');
        var dataLanguage = document.body.getAttribute('data-language-long');
        if (dataLanguage && dataLanguage.length > 0) {
            this.language = dataLanguage;
        }
        this.contentElement.innerHTML = this.loadingIndicatorDark;
        this.handleLoadContent();
    }

    private handleLoadContent(): void {
        fetch(this.targetToLoad, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'accept-language': this.language,
                // todo: why? if we change to a api controller we don't have this problem...
                'X-Requested-With': 'XMLHttpRequest' // otherwise accept-language is ignored
            },
            credentials: 'include'
        })
            .then(response => {
                const contentType = response.headers.get('content-type');
                if (contentType && contentType.includes('text/html')) {
                    return response.text();
                }
            })
            .then(data => {
                this.handleDataContentResult(data);
            });
    }

    private handleDataContentResult(data: string) {
        if (data != null && data.length > 0) {
            this.contentElement.innerHTML = data;
            const formElementWrappers = this.contentElement.getElementsByClassName('js-vehicle-storage-form');
            if (formElementWrappers && formElementWrappers.length > 0 ) {
                this.formElementWrapper = formElementWrappers[0] as HTMLElement;
                this.initializeContentForm();
            }
        }
    }

    private handleSubmitForm(event: Event) {
        event.preventDefault();
        if($(this.formElement).valid()){
            const formData = $(this.formElement).serialize();
            this.formElementWrapper.innerHTML = this.loadingIndicator;
            fetch(this.formElement.action, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'accept-language': this.language,
                    // todo: why? if we change to a api controller we don't have this problem...
                    'X-Requested-With': 'XMLHttpRequest' // otherwise accept-language is ignored
                },
                body: formData,
                credentials: 'include'
            })
                .then(response => {
                    const contentType = response.headers.get('content-type');
                    const redirected = response.redirected;
                    const url = response.url
                    if (redirected && url) {
                        window.location.href = response.url;
                        throw new Error("redirecting so break out of promise chain.");
                    }
                    if (contentType && contentType.includes('text/html')) {
                        return response.text();
                    }
                })
                .then(data => {
                    this.handleDataFormResult(data);
                });
        }
    }

    private handleDataFormResult(data: string){
        if (data != null && data.length > 0) {
            this.formElementWrapper.innerHTML = data;
            this.initializeContentForm();
        }
    }

    private initializeContentForm() {
        if (this.formElementWrapper) {
            const formElements = this.formElementWrapper.getElementsByTagName('form');
            if (formElements && formElements.length > 0) {
                this.formElement = formElements[0];
                this.formElement.addEventListener('submit', (e) => this.handleSubmitForm(e));

                // extend jquery range validator to work for required checkboxes
                var defaultRangeValidator = $.validator.methods.range;
                $.validator.methods.range = function (value, element, param) {
                    if (element.type === 'checkbox') {
                        // if it's a checkbox return true if it is checked
                        return element.checked;
                    } else {
                        // otherwise run the default validation function
                        return defaultRangeValidator.call(this, value, element, param);
                    }
                }
                $.validator.unobtrusive.parse('form');
            }

        }
    }
}